import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToolsService} from '../tools/tools.service';

@Injectable({
  providedIn: 'root'
})
export class ResellerService {

  constructor(
    private http: HttpClient,
    private toolsSrv: ToolsService
  ) {
  }

  getImage(url: string) {
    return this.http.get(`${this.toolsSrv.getApiEndpoint()}resellers/${url}`).toPromise();
  }
}
